import { AddressSchema } from "@redotech/account-common/address-schema";
import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";

export const getReturnPickupAvailability = {
  name: "getReturnPickupAvailability" as const,
  input: z.object({
    returnId: zExt.objectId(),
    address: AddressSchema.nullable(),
    merchantAddress: AddressSchema.nullable(),
  }),
  output: z.object({ pickupFee: z.number().nullable() }),
};
